export default "__VITE_ASSET__9P4BfmYb__"